import { render, staticRenderFns } from "./AskAmy.vue?vue&type=template&id=c5b0492a"
import script from "./AskAmy.vue?vue&type=script&lang=js"
export * from "./AskAmy.vue?vue&type=script&lang=js"
import style0 from "./AskAmy.vue?vue&type=style&index=0&id=c5b0492a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports